import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicRoutingModule } from './public.routing';
import { LoginComponent } from './login/login.component';
import { LoginService } from 'src/app/Services/login.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecuperarSenhaComponent } from './recuperar-senha/recuperar-senha.component';
import { PaginaInicialComponent } from './pagina-inicial/pagina-inicial.component';
import { HeaderPublicoComponent } from 'src/app/Components/header-publico/header-publico.component';
import { HomePublicoComponent } from './home-publico/home-publico.component';
import { RouterModule } from '@angular/router';
import { PPASignificadoComponent } from 'src/app/Pages/public/ppa-significado/ppa-significado.component';
import { DiretrizesEstadoComponent } from 'src/app/Pages/public/diretrizes-estado/diretrizes-estado.component';
import { ConhecaMaisComponent } from 'src/app/Pages/public/conheca-mais/conheca-mais.component';
import { BlockUIModule } from 'ng-block-ui';
import { CarrosselComponent } from 'src/app/Components/carrossel/carrossel.component';
import { PreCadastroComponent } from 'src/app/Pages/public/pre-cadastro/pre-cadastro.component';
import { ParticipanteService } from 'src/app/Services/participante.service';
import { InputMaskModule } from 'primeng/inputmask';
@NgModule({
  declarations: [
    PaginaInicialComponent,
    LoginComponent,
    RecuperarSenhaComponent,
    HeaderPublicoComponent,
    HomePublicoComponent,
    PPASignificadoComponent,
    DiretrizesEstadoComponent,
    ConhecaMaisComponent,
    CarrosselComponent,
    PreCadastroComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PublicRoutingModule,
    RouterModule,
    BlockUIModule.forRoot(),
    InputMaskModule
  ],
  exports: [FormsModule, ReactiveFormsModule],
  providers: [LoginService, ParticipanteService]
})
export class PublicModule { }
